(function () {
  var PRODUCT_HANDLES = [
    '10x-precision-weight-management-supplements',
    '10x-precision-nutrition-supplements'
  ];
  var onTargetProduct = PRODUCT_HANDLES.some(function (handle) {
    return window.location.pathname.indexOf('/products/' + handle) !== -1;
  });
  if (!onTargetProduct) {
    return;
  }

  var MAX_WAIT_MS = 60000;

  var REWRITES = [
    {
      match: /\s*\/?\s*3\s*months?\b/i,
      replacement: ' for a <strong style="font-weight:700">3-month supply</strong> delivered quarterly'
    },
    {
      match: /\s*\/?\s*one[\s-]?time\b/i,
      replacement: ' for a <strong style="font-weight:700">3-month supply</strong>'
    }
  ];

  var PRICE_SELECTORS = [
    '.appstle_sellingPlan_price',
    '.appstle_subscription_amount',
    '.appstle_onetime_amount',
    '.appstle_price_block'
  ].join(',');
  var MARK_ATTR = 'data-ten-x-text-applied';

  function rewriteTileText() {
    var nodes = document.querySelectorAll(PRICE_SELECTORS);
    var anyApplied = false;
    nodes.forEach(function (el) {
      var original = el.textContent;
      if (!original) return;
      var rewritten = original;
      for (var i = 0; i < REWRITES.length; i++) {
        if (REWRITES[i].match.test(rewritten)) {
          rewritten = rewritten.replace(REWRITES[i].match, REWRITES[i].replacement);
          break;
        }
      }
      if (rewritten === original) return;
      if (el.getAttribute(MARK_ATTR) === rewritten) return;
      el.innerHTML = rewritten;
      el.setAttribute(MARK_ATTR, rewritten);
      anyApplied = true;
    });
    return anyApplied;
  }

  function init() {
    var observer = null;
    var timeoutId = null;

    function stopWatching() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    }

    if (rewriteTileText()) {
      return;
    }

    observer = new MutationObserver(function () {
      if (rewriteTileText()) {
        stopWatching();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    timeoutId = setTimeout(stopWatching, MAX_WAIT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
